import { useEffect, useState } from "react";
import styled from "styled-components";
import {
  getPagesHeightById,
  scrollY_to_target,
} from "../utills/utills";
import docData from '../utills/page_contents.json'

const HeaderContainer = styled.div`
  position: fixed;
  width: 85%;
  padding: 5% 7.5%;
  padding-top: 5%;
  z-index: 2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 1024px) {
    padding-top: 7%;
    gap: 5px;
    flex-direction: column;
    align-items: center;
  }
  @media (max-width: 723px) {
    padding-top: 10%;
    gap: 20px;
  }
  @media (max-width: 500px) {
    padding-top: 15%;
  }
`;
const Logo = styled.h1`
  font-size: 2rem;
  font-weight: 600;
  white-space: nowrap;
  margin-right: 0.5rem;
  @media (max-width: 723px) {
    font-size: 1.4rem;
  }
`;
const Navigation = styled.div`
  font-weight: 600;
`;
const NaviMenus = styled.ul`
  display: flex;
  gap: 1.8rem;
  transition: gap 1s;
  @media (max-width: 1024px) {
    gap: 1.2rem;
  }
  @media (max-width: 723px) {
    font-size: 0.8rem;
  }
  @media (max-width: 350px) {
    gap: 0.8rem;
    font-size: 0.63rem;
  }
`;
const NaviMenu = styled.li`
  text-align: center;
  text-transform: capitalize;
  cursor: pointer;
  & h1 {
    color: ${(props) => props.theme.textColor_inactive};
  }
  & h1.active {
    color: ${(props) => props.theme.textColor_base};
    text-decoration: underline;
  }
`;

function Navi() {
  const [currentPage, setCurrentPage] = useState<string>("introduction");
  const getCurrntPage_height = () => {
    window.addEventListener("resize", () => {
      setCurrentPage(getPagesHeightById(docData.pages));
    });
    window.addEventListener("scroll", () => {
      setCurrentPage(getPagesHeightById(docData.pages));
    });
  };
  useEffect(() => {
    getCurrntPage_height();
    return getCurrntPage_height();
  }, []);

  return (
    <HeaderContainer>
      <Logo>BLE Player</Logo>
      <Navigation>
        <NaviMenus>
          {docData.pages.filter((_,index)=> index>0).map((page) => (
            <NaviMenu key={page} onClick={() => scrollY_to_target(`${page}`)}>
              {currentPage === page ? (
                <h1 className="active">{page}</h1>
              ) : (
                <h1>{page}</h1>
              )}
            </NaviMenu>
          ))}
        </NaviMenus>
      </Navigation>
    </HeaderContainer>
  );
}

export default Navi;
